import "./Account.css";
//import { IAppUser } from "../../models/IAppUser";
import CharList from "../../components/Character/CharacterList/CharList";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../Services/AppInsightService";
import { useAuth } from "../../auth/AuthContext";

interface IProps {
    // user: IAppUser;
    // userAuthenticated: boolean
}

//const Account: React.FC<IProps> = ({ user, userAuthenticated }) => {
const Account: React.FC<IProps> = () => {
    const { user, userAuthenticated } = useAuth();

    return (
        <div className="account-context">
            <div>

            </div>
            {!userAuthenticated ? 
                <div>
                    <br /><br />Login to view/edit your Account.
                </div>
            : 
                <div>
                    <h2>You are logged in to your Account.</h2>
                    <CharList />
                </div>
            }
        </div>
    );
}

export default withAITracking(reactPlugin, Account);
